export const StaticCellTypes = {
    topic: 'topic',
};
